export default "__VITE_ASSET__BF8tGrEC__"